import React from 'react'
import PayrollCalculator from '../components/PayrollCalculator'
import {MapPin, DollarSign, TrendingUp} from 'lucide-react'

const WashingtonCalculatorPage = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-50 to-emerald-50 py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <div className="flex items-center justify-center mb-4">
              <MapPin className="w-10 h-10 text-blue-800 mr-3" />
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
                Washington Salary Calculator
              </h1>
            </div>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Calculate your Washington paycheck with no state income tax. Free salary calculator WA with accurate federal tax withholding.
            </p>
          </div>

          {/* Calculator with WA pre-selected */}
          <PayrollCalculator defaultState="Washington" />
        </div>
      </section>

      {/* SEO Content */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Salary Calculator WA - No State Income Tax
            </h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Washington State is one of the few states with no personal income tax, which means your paycheck only includes federal tax deductions and FICA taxes. Our Washington salary calculator shows you exactly how much you'll take home without state income tax withholding. This makes Washington an attractive state for maximizing your net pay.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Whether you're working in Seattle, Spokane, Tacoma, Vancouver, or anywhere else in the Evergreen State, our calculator provides accurate paycheck estimates with federal income tax, Social Security, and Medicare deductions only.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="bg-blue-50 p-6 rounded-lg">
              <DollarSign className="w-8 h-8 text-blue-800 mb-3" />
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Washington Tax Benefits</h3>
              <ul className="text-gray-600 space-y-2">
                <li>• No state income tax (0%)</li>
                <li>• Only federal taxes apply</li>
                <li>• Higher take home pay vs. other states</li>
                <li>• Simple tax calculations</li>
              </ul>
            </div>

            <div className="bg-emerald-50 p-6 rounded-lg">
              <TrendingUp className="w-8 h-8 text-emerald-700 mb-3" />
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Deductions in WA</h3>
              <ul className="text-gray-600 space-y-2">
                <li>• Federal income tax (varies by income)</li>
                <li>• Social Security: 6.2%</li>
                <li>• Medicare: 1.45%</li>
                <li>• No state tax deductions</li>
              </ul>
            </div>
          </div>

          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Understanding Your Washington Paycheck
            </h2>
            <p className="text-gray-600 leading-relaxed">
              Washington paychecks are simpler than most states because there's no state income tax to calculate. Your deductions include federal income tax based on your W-4 filing status and IRS tax brackets, plus FICA taxes (Social Security at 6.2% and Medicare at 1.45%). This simplicity means more money in your pocket compared to high-tax states. Our salary calculator shows you the exact breakdown of federal withholdings and your final net pay per paycheck.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-blue-800 py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Calculate Your Washington Take Home Pay
          </h2>
          <p className="text-blue-100 mb-6">
            Free Washington salary calculator with no state income tax - maximize your net pay.
          </p>
          <a
            href="#calculator"
            className="inline-block bg-white text-blue-800 font-semibold px-8 py-3 rounded-lg hover:bg-gray-100 transition-colors"
          >
            Calculate Now
          </a>
        </div>
      </section>
    </div>
  )
}

export default WashingtonCalculatorPage
